"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleExistingDriverAdderWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var VehicleExistingDriverAdderWidget = exports.VehicleExistingDriverAdderWidget = /** @class */ (function (_super) {
    __extends(VehicleExistingDriverAdderWidget, _super);
    function VehicleExistingDriverAdderWidget(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.navigateToPage = _this.getSetting("navigateToPage", undefined);
        var vehicle = _this.props.interaction.vehicles[_this.vehicleIndex];
        _this.drivers = [];
        if (!vehicle.driverIds.includes(_this.props.interaction.policyHolder.personId)) {
            _this.drivers.push(_this.props.interaction.policyHolder);
        }
        _this.state = {
            vehicle: vehicle,
            driverToAdd: ""
        };
        if (_this.props.interaction.additionalDrivers) {
            (_a = _this.drivers).push.apply(_a, _this.props.interaction.additionalDrivers.filter(function (driver) { return !vehicle.driverIds.includes(driver.personId); }));
        }
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    VehicleExistingDriverAdderWidget.prototype.render = function () {
        var driversToRender = this.drivers.map(function (driver, i) { return (React.createElement("option", { key: i, value: driver.personId },
            driver.firstName,
            " ",
            driver.lastName)); });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "form-group" },
                React.createElement("label", null, "Please choose one of the existing drivers to add to the vehicle"),
                React.createElement("div", { className: "input-group" },
                    React.createElement("select", { className: "form-control", onChange: this.handleOnChangeEvent, id: "existingDrivers" },
                        React.createElement("option", { value: '' }, "Please select..."),
                        driversToRender))),
            React.createElement("button", { type: "button", className: "btn btn-primary btn-next", onClick: this.handleClick, id: "addDriver" }, "Add driver")));
    };
    VehicleExistingDriverAdderWidget.prototype.handleOnChangeEvent = function (event) {
        this.setState({ driverToAdd: event.target.value });
    };
    VehicleExistingDriverAdderWidget.prototype.handleClick = function () {
        var vehicle = this.state.vehicle;
        vehicle.driverIds.push(this.state.driverToAdd);
        this.setState({ vehicle: vehicle });
        this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), this.state.vehicle);
        if (this.navigateToPage) {
            this.props.engine.navigate(this.navigateToPage, true);
        }
        else {
            this.props.engine.navigate("coverOptions", true);
        }
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "].driverIds"));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], VehicleExistingDriverAdderWidget.prototype, "changelogRecorder", void 0);
    return VehicleExistingDriverAdderWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=VehicleExistingDriverAdderWIdget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/VehicleExistingDriverAdderWIdget.js
// module id = 2584
// module chunks = 0